import styled from "styled-components";
import { Close } from "styled-icons/evaicons-solid";


export default styled(Close)`
  color: white;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 2rem;
  cursor: pointer;
`;